import { ColumnType } from '~shared/rundown/column'

import { RichtextColumnCellOutput } from '../rundown/cell/cell-types/richtext/RichtextColumnCellOutput'
import { SelectColumnCellOutput } from '../rundown/cell/cell-types/select/SelectColumnCellOutput'
import { useCellColumn } from '../rundown/cell/cell.hooks'

/**
 * Renders a cell inside an Cue in Rundown Output.
 */
export function OutputCell({ style }: { style: React.CSSProperties }) {
  const column = useCellColumn()

  // Determine which component to render based on column type
  if (column.type === ColumnType.SELECT) {
    return <SelectColumnCellOutput />
  } else {
    return <RichtextColumnCellOutput style={style} />
  }
}
